import type { IconNode } from '../types';

/**
 * @name belt
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNy4zIDlIM2MtLjYgMC0xLS40LTEtMVY0YzAtLjYuNC0xIDEtMWg0LjMiIC8+CiAgPHBhdGggZD0iTTYgNmgzIiAvPgogIDxwYXRoIGQ9Ik0xMyA2aC4wMSIgLz4KICA8cmVjdCB3aWR0aD0iMTAiIGhlaWdodD0iOCIgeD0iNyIgeT0iMiIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTE2LjcgM0gyMWMuNiAwIDEgLjQgMSAxdjRjMCAuNi0uNCAxLTEgMWgtNC4zIiAvPgogIDxwYXRoIGQ9Im0xMC41IDEwLTguMSA2LjIiIC8+CiAgPHBhdGggZD0iTTIxLjYgOC44IDEyLjIgMTYiIC8+CiAgPHBhdGggZD0iTTMgMjJjLS42IDAtMS0uNC0xLTF2LTRjMC0uNi40LTEgMS0xaDE2bDMgMy0zIDNaIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/belt
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const belt: IconNode = [
  ['path', { d: 'M7.3 9H3c-.6 0-1-.4-1-1V4c0-.6.4-1 1-1h4.3', key: '1imxws' }],
  ['path', { d: 'M6 6h3', key: 'qh3tn0' }],
  ['path', { d: 'M13 6h.01', key: 'cksc78' }],
  ['rect', { width: '10', height: '8', x: '7', y: '2', rx: '2', key: '3xru4v' }],
  ['path', { d: 'M16.7 3H21c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-4.3', key: 'vnlabj' }],
  ['path', { d: 'm10.5 10-8.1 6.2', key: 'qz383w' }],
  ['path', { d: 'M21.6 8.8 12.2 16', key: 'fvikpm' }],
  ['path', { d: 'M3 22c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1h16l3 3-3 3Z', key: '1n2mdy' }],
];

export default belt;
